module.exports = __webpack_public_path__ + "./stella-illustration_9baf75fb4e7c9bd431290c51e5ced82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/stella-illustration.png
// module id = 426
// module chunks = 0